import { tokenDecode } from './decode'

const getJwtTime = () => Math.floor(Date.now() / 1000)

export const tokenExpiration = (token: string) => tokenDecode(token).exp - getJwtTime()
